import Dropdown from "app/components/Dropdown";
import { CheckIcon, StatusIcon } from "app/components/Icons";
import { selectTicketStatus } from "app/redux/selector";
import { ITicketStatus } from "app/types";
import clsx from "clsx";
import React from "react";
import { useSelector } from "react-redux";

interface CustomProps {
  value?: string;
  setValue?: (value: ITicketStatus) => void;
  trigger: React.ReactNode;
  align?: "start" | "end" | "center";
  isHeader?: string;
  dropDownClassName?: string;
  onOpen?: () => void;
  onClose?: () => void;
}

const CommonStatusSelection: React.FC<CustomProps> = ({
  setValue,
  value,
  trigger,
  align = "center",
  isHeader,
  dropDownClassName,
  onOpen,
  onClose,
}) => {
  const ticketStatusList = useSelector(selectTicketStatus);
  const MenuItems = ticketStatusList?.map((ele) => {
    if (ele)
      return {
        label: (
          <div
            className={`flex items-center justify-between hover:bg-gray-50 rounded-md transition-colors w-full  `}
            aria-label={`Profile of ${ele.name}`}
          >
            {/* Left: Icon + Text */}
            <div className="flex items-center gap-[4px]">
              <StatusIcon color={ele?.color} />
              <span
                className={clsx("text-sm font-normal ")}
                style={{ color: ele.color }}
              >
                {ele.name}
              </span>
            </div>

            {/* Right: Tick icon only if selected */}
            {value === ele._id && <CheckIcon color="#5A8DF1" />}
          </div>
        ),
        action: () => {
          setValue && setValue(ele);
        },
      };
    else return { label: "", action: () => {} };
  });

  return (
    <Dropdown
      trigger={trigger}
      projectInfoIcon={
        <div className="flex flex-col gap-2">
          {isHeader && (
            <div className="flex items-center justify-between px-4 py-3 text-secondary tracking-[0.56px] text-sm font-semibold leading-[21px] uppercase ">
              <span>{isHeader}</span>
            </div>
          )}
        </div>
      }
      menuItems={MenuItems ? MenuItems : []}
      align={align}
      className="py-2"
      dropDownClassName={dropDownClassName}
      onOpen={onOpen}
      onClose={onClose}
    />
  );
};

export default CommonStatusSelection;
